(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutec-calculators"] && !Shopify.designMode) return;
  try {
    (() => {
"use strict";
const scriptKey = Symbol.for("nutec.calculators.theme.v1");
if (window[scriptKey]) { window[scriptKey](); return; }
function mount() {
  document.querySelectorAll("#nutec-calculator-app").forEach(app => {
    if (app.dataset.calculatorReady === "true") return;
    app.dataset.calculatorReady = "true";
const CONFIG = {
  cementBagKg: 50,
  cementBulkDensityKgM3: 1440,
  dryFactorConcrete: 1.54,
  dryFactorMortar: 1.33,
  dryFactorPlaster: 1.33,
  dryFactorScreed: 1.33,
  mortarJointM: 0.010,

  concreteMixes: {
    low:    {label:"Low · approx. 10–15 MPa", cement:1, sand:3, stone:6},
    medium: {label:"Medium · approx. 20–25 MPa", cement:1, sand:2, stone:4},
    high:   {label:"High · approx. 30–35 MPa", cement:1, sand:1.5, stone:3}
  },

  masonryUnits: {
    common:{label:"Common stock brick",l:.222,w:.106,h:.073},
    bs190:{label:"BS190",l:.190,w:.090,h:.090},
    jumbo2:{label:"Jumbo 2",l:.290,w:.090,h:.090},
    maxi:{label:"Maxi",l:.290,w:.140,h:.090},
    m90:{label:"M90 block",l:.390,w:.090,h:.190},
    m140:{label:"M140 block",l:.390,w:.140,h:.190},
    m190:{label:"M190 block",l:.390,w:.190,h:.190}
  },

  nutecPlankOverlapM: 0.025,
  ibrCoverM: 0.686,
  corrugated85CoverM: 0.610,
  corrugated105CoverM: 0.762,
  bigSixOverallFirstM: 0.920,
  bigSixNetAdditionalM: 0.875
};


const $ = id => app.querySelector(`[id="${id}"]`);
const n = id => { const value = $(id)?.value; return value === "" || value == null ? 0 : Number(value); };
const clamp0 = value => Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : 0;
const round = (value, decimals=2) => {
  if (!Number.isFinite(Number(value))) throw new RangeError("Result is outside the supported range.");
  const scale = 10 ** decimals;
  if (!Number.isFinite(Number(value) * scale)) throw new RangeError("Result is outside the supported range.");
  return Math.round((Number(value) + Number.EPSILON) * scale) / scale;
};
const roundUp = (value, step=1) => Math.ceil(value / step) * step;
const fmt = (value, decimals=2) => round(value, decimals).toLocaleString("en-ZA", {maximumFractionDigits:decimals});
const money = value => {
  if (!Number.isFinite(Number(value))) throw new RangeError("Cost is outside the supported range.");
  return new Intl.NumberFormat("en-ZA", {style:"currency", currency:"ZAR"}).format(Number(value));
};
const parsePair = value => String(value).split(",").map(Number);
const escape = value => String(value).replace(/[&<>"']/g, c => ({"&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;"}[c]));
const persistentFields = [...app.querySelectorAll("[data-persist][id]")];
const initialSettings = new Map(persistentFields.map(el => [el.id, el.type === "checkbox" ? el.checked : el.value]));
const fieldDefaults = new Map([...app.querySelectorAll(".calc-view input,.calc-view select")].map(el => [el, el.type === "checkbox" ? el.checked : el.value]));
const views = [...app.querySelectorAll(".calc-view")];
let toastTimer;
function getSettings() {
  return {wastage:clamp0(n("wastage")), cementPrice:clamp0(n("cementPrice")), sandPrice:clamp0(n("sandPrice")), stonePrice:clamp0(n("stonePrice")), vatRate:clamp0(n("vatRate")), includeVat:!!$("includeVat")?.checked};
}
function withWaste(value) { return value * (1 + getSettings().wastage / 100); }
function qty(value, unit, decimals=2) { return `${fmt(value, decimals)} ${unit}`.trim(); }
function validPositive(values, message) {
  if (values.some(value => !Number.isFinite(value) || value <= 0)) { alert(message); return false; }
  return true;
}
function resultRow(label, value) { return `<div class="result-row"><span>${escape(label)}</span><strong>${escape(value)}</strong></div>`; }
function buildCost(items) {
  if (items.some(item => !Number.isFinite(item.value) || item.value < 0)) throw new RangeError("Cost is outside the supported range.");
  const settings = getSettings();
  const priced = items.filter(item => item.value > 0);
  if (!priced.length) return null;
  const subtotal = priced.reduce((sum, item) => sum + item.value, 0);
  const vat = settings.includeVat ? subtotal * settings.vatRate / 100 : 0;
  if (![subtotal,vat,subtotal+vat].every(Number.isFinite)) throw new RangeError("Cost is outside the supported range.");
  return {items:priced, subtotal, vat, total:subtotal+vat};
}
function invalidate(view) {
  const result = view?.querySelector(".result-summary");
  const empty = view?.querySelector(".result-empty");
  if (result) { result.classList.remove("show"); result.innerHTML = ""; }
  if (empty) empty.style.display = "";
}
function invalidateAll() { views.forEach(invalidate); }
function renderResult(resultId, emptyId, data) {
  if (/Infinity|NaN|∞/.test(JSON.stringify(data))) throw new RangeError("Result is outside the supported range.");
  const result = $(resultId), empty = $(emptyId);
  if (!result || !empty) return;
  const sections = (data.sections || []).map(section => `<div class="result-section-title">${escape(section.title)}</div>${section.rows.map(row=>resultRow(row.label,row.value)).join("")}`).join("");
  let costHtml = "";
  if (data.costs) {
    costHtml = `<div class="result-section-title">Estimated Cost</div><div class="total-block">${data.costs.items.map(item=>resultRow(item.label,money(item.value))).join("")}${resultRow("Subtotal",money(data.costs.subtotal))}${data.costs.vat>0 ? resultRow(`VAT (${getSettings().vatRate}%)`,money(data.costs.vat)) : ""}${resultRow("Estimated total",money(data.costs.total))}</div>`;
  }
  result.innerHTML = `<div class="result-hero"><span>${escape(data.heroLabel)}</span><strong>${escape(data.heroValue)}</strong></div>${(data.rows || []).map(row=>resultRow(row.label,row.value)).join("")}${sections}${costHtml}<div class="form-actions result-actions"><button class="btn btn-secondary btn-small" type="button" data-calculator-action="copy">Copy result</button><button class="btn btn-primary btn-small" type="button" data-calculator-action="print">Print / Save PDF</button></div><div class="result-note">ESTIMATE ONLY — The customer must confirm measurements, quantities, effective coverage, product suitability, laps and installation requirements before purchase. Actual material usage may vary.</div>`;
  empty.style.display = "none";
  result.classList.add("show");
  result.setAttribute("role", "status");
  result.setAttribute("aria-live", "polite");
}
function clearCalc(id) {
  const view = $(id);
  if (!view) return;
  view.querySelectorAll("input:not([readonly]),select").forEach(el => {
    if (el.hasAttribute("data-persist")) return;
    if (el.type === "checkbox") el.checked = fieldDefaults.get(el);
    else el.value = fieldDefaults.get(el) ?? "";
    el.removeAttribute("aria-invalid");
  });
  invalidate(view);
  updateBoardApplication();
}
function showToast(message) {
  const el = $("toast");
  if (!el) return;
  el.textContent = message;
  el.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>el.classList.remove("show"),1800);
}
function setSettingsOpen(open) {
  const drawer = $("settingsDrawer");
  if (!drawer) return;
  drawer.classList.toggle("open",open);
  drawer.setAttribute("aria-hidden",String(!open));
  const button = app.querySelector(".toolbar-actions .btn-secondary");
  button?.setAttribute("aria-expanded",String(open));
  if (open) $("wastage")?.focus();
  else button?.focus();
}
function validNumberField(el) {
  if (el.value === "") return !el.validity?.badInput;
  const value = Number(el.value);
  return Number.isFinite(value) && value >= 0 && (el.min === "" || value >= Number(el.min)) && (el.max === "" || value <= Number(el.max)) && (el.step !== "1" || Number.isInteger(value));
}
function validateInputs(view) {
  const fields = [...view.querySelectorAll('input[type="number"]'), ...app.querySelectorAll('.settings-drawer input[type="number"]')];
  const invalid = fields.find(el=>!validNumberField(el));
  if (invalid) {
    invalid.setAttribute("aria-invalid","true");
    if (invalid.closest(".settings-drawer")) setSettingsOpen(true);
    invalid.focus();
    alert("Enter finite, nonnegative values within the shown limits. Counts must be whole numbers.");
    return false;
  }
  const badSelect = [...view.querySelectorAll("select")].find(el=>!el.value || (el.value.includes(",") && (parsePair(el.value).length!==2 || parsePair(el.value).some(value=>!Number.isFinite(value)||value<=0))));
  if (badSelect) { badSelect.focus(); alert("Choose a valid product size or option."); return false; }
  return true;
}
function saveSettings() {
  if (!validateInputs(app.querySelector(".calc-view.active") || app)) return;
  const data = Object.fromEntries(persistentFields.map(el=>[el.id,el.type==="checkbox" ? el.checked : el.value]));
  try { localStorage.setItem("nutecHardwareCalculatorSettings",JSON.stringify(data)); showToast("Settings saved"); }
  catch { showToast("Settings apply for this visit; browser storage is unavailable."); }
  invalidateAll();
}
function loadSettings() {
  let data;
  try { data = JSON.parse(localStorage.getItem("nutecHardwareCalculatorSettings") || "{}"); } catch { return; }
  if (!data || typeof data!=="object" || Array.isArray(data)) return;
  persistentFields.forEach(el=>{
    if (!Object.prototype.hasOwnProperty.call(data,el.id)) return;
    if (el.type==="checkbox") { if (typeof data[el.id]==="boolean") el.checked=data[el.id]; return; }
    if (typeof data[el.id]!=="number" && typeof data[el.id]!=="string") return;
    const original=el.value;
    el.value=String(data[el.id]);
    if (!validNumberField(el) || (String(data[el.id]).trim()!=="" && el.value==="")) el.value=original;
  });
}
function resetSettings() {
  try { localStorage.removeItem("nutecHardwareCalculatorSettings"); } catch {}
  persistentFields.forEach(el=>{ if (el.type==="checkbox") el.checked=initialSettings.get(el.id); else el.value=initialSettings.get(el.id); });
  invalidateAll();
  showToast("Settings reset");
}
async function copyActiveResult() {
  const active = app.querySelector(".calc-view.active .result-summary.show");
  if (!active) return;
  const text = (active.innerText || active.textContent).replace(/Copy result/g,"").replace(/Print \/ Save PDF/g,"").trim();
  try { await navigator.clipboard.writeText(text); showToast("Result copied"); } catch { showToast("Copy unavailable; use Print / Save PDF."); }
}
function hasView(id) { return views.some(view=>view.id===id); }
function defaultCalculator() { return hasView(app.dataset.defaultCalculator) ? app.dataset.defaultCalculator : "concrete"; }
function routeCalculator() {
  let hash="";
  try { hash=decodeURIComponent(location.hash.slice(1)).toLowerCase(); } catch {}
  const query=new URL(location.href).searchParams.get("calculator");
  return hasView(hash) ? hash : hasView(query) ? query : defaultCalculator();
}
function activateCalculator(id, shouldScroll=true, updateHistory=false) {
  if (!hasView(id)) id=defaultCalculator();
  app.querySelectorAll(".calc-nav button[data-target]").forEach(button=>{
    const active=button.dataset.target===id;
    button.classList.toggle("active",active);
    if (active) button.setAttribute("aria-current","true"); else button.removeAttribute("aria-current");
  });
  views.forEach(view=>{ const active=view.id===id; view.classList.toggle("active",active); view.setAttribute("aria-hidden",String(!active)); });
  const mobile=$("mobileCalculatorSelect");
  if (mobile) mobile.value=id;
  const activeButton=[...app.querySelectorAll(".calc-nav button[data-target]")].find(button=>button.dataset.target===id);
  const label=$("mobileCurrentCalculator");
  if (label) label.textContent=activeButton?.dataset.name || activeButton?.querySelector(".nav-name")?.textContent || id;
  if (updateHistory) {
    const url=new URL(location.href);
    url.hash=id;
    if (url.searchParams.has("calculator")) url.searchParams.set("calculator",id);
    if (url.href!==location.href) history.pushState(null,"",url);
  }
  if (shouldScroll && window.innerWidth<1024) $(id)?.scrollIntoView({behavior:window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",block:"start"});
}
function updateBoardApplication() {
  const application=$("nutecBoardApplication"), note=$("nutecBoardApplicationNote"), thickness=$("nutecBoardThickness");
  if (!application) return;
  if (application.value==="Floor") {
    const option=[...(thickness?.options || [])].find(el=>el.textContent.trim()==="15 mm");
    if (option) thickness.value=option.value;
    if (note) note.textContent="Floor selected: 15 mm is highlighted as the standard calculator option. Confirm board specification and support spacing before purchase.";
  } else if (note) note.textContent="Choose the intended use of the boards.";
}
function calculateConcrete(){
  const L=n("concreteLength"), W=n("concreteWidth"), D=n("concreteThickness")/1000;
  if(!validPositive([L,W,D],"Enter valid concrete dimensions.")) return;

  const mix=CONFIG.concreteMixes[$("concreteStrength").value];
  const net=L*W*D;
  const wet=withWaste(net);
  const dry=wet*CONFIG.dryFactorConcrete;
  const parts=mix.cement+mix.sand+mix.stone;
  const cementM3=dry*(mix.cement/parts);
  const sandM3=dry*(mix.sand/parts);
  const stoneM3=dry*(mix.stone/parts);
  const cementBags=Math.ceil((cementM3*CONFIG.cementBulkDensityKgM3)/CONFIG.cementBagKg);
  const sandOrder=roundUp(sandM3,.1);
  const stoneOrder=roundUp(stoneM3,.1);
  const s=getSettings();

  const costs=buildCost([
    {label:`Cement · ${cementBags} bags`,value:cementBags*s.cementPrice},
    {label:`Sand · ${qty(sandOrder,"m³",1)}`,value:sandOrder*s.sandPrice},
    {label:`Stone · ${qty(stoneOrder,"m³",1)}`,value:stoneOrder*s.stonePrice}
  ]);

  renderResult("concreteResult","concreteEmpty",{
    heroLabel:"Concrete including wastage",
    heroValue:qty(wet,"m³",2),
    rows:[
      {label:"Net concrete volume",value:qty(net,"m³",2)},
      {label:"Project type",value:$("concreteProject")?.value || "Custom"},
      {label:"Concrete class",value:mix.label},
      {label:"Nominal mix",value:`${mix.cement}:${mix.sand}:${mix.stone}`},
      {label:"Cement",value:`${cementBags} × 50 kg bags`},
      {label:"Sand",value:qty(sandOrder,"m³",1)},
      {label:"Stone",value:qty(stoneOrder,"m³",1)}
    ],
    costs
  });
}



function calculateMasonry(){
  const unit=CONFIG.masonryUnits[$("masonryType").value];
  const L=n("wallLength"), H=n("wallHeight"), openings=clamp0(n("openingsArea"));
  if(!validPositive([L,H],"Enter valid wall length and height.")) return;

  const faceArea=L*H-openings;
  if(faceArea<=0){alert("Openings cannot equal or exceed wall area.");return;}

  const wallType=$("wallType").value;
  const leaves=wallType==="single"?1:2;
  const moduleArea=(unit.l+CONFIG.mortarJointM)*(unit.h+CONFIG.mortarJointM);
  const unitsRaw=(faceArea/moduleArea)*leaves;
  const unitsOrder=Math.ceil(withWaste(unitsRaw));

  const envelope=faceArea*unit.w*leaves;
  const solids=unitsRaw*unit.l*unit.w*unit.h;
  const mortarWet=Math.max(0,envelope-solids);
  const mortarOrder=withWaste(mortarWet);
  const dry=mortarOrder*CONFIG.dryFactorMortar;
  const sandParts=$("mortarClass").value==="class1"?4:6;
  const total=1+sandParts;
  const cementM3=dry/total;
  const sandM3=dry*(sandParts/total);
  const cementBags=Math.ceil(cementM3*CONFIG.cementBulkDensityKgM3/CONFIG.cementBagKg);
  const sandOrder=roundUp(sandM3,.1);
  const s=getSettings();
  const unitPrice=clamp0(n("masonryUnitPrice"));

  const costs=buildCost([
    {label:`${unit.label} · ${unitsOrder} units`,value:unitsOrder*unitPrice},
    {label:`Cement · ${cementBags} bags`,value:cementBags*s.cementPrice},
    {label:`Sand · ${qty(sandOrder,"m³",1)}`,value:sandOrder*s.sandPrice}
  ]);

  renderResult("masonryResult","masonryEmpty",{
    heroLabel:"Masonry units including wastage",
    heroValue:`${unitsOrder.toLocaleString("en-ZA")} units`,
    rows:[
      {label:"Net wall face area",value:qty(faceArea,"m²",2)},
      {label:"Masonry unit",value:unit.label},
      {label:"Wall leaves",value:String(leaves)},
      {label:"Approx. mortar",value:qty(mortarOrder,"m³",2)},
      {label:"Cement",value:`${cementBags} × 50 kg bags`},
      {label:"Building sand",value:qty(sandOrder,"m³",1)}
    ],
    costs
  });
}



function calculatePlaster(){
  const L=n("plasterLength"),H=n("plasterHeight"),T=n("plasterThickness")/1000;
  const openings=clamp0(n("plasterOpenings")), sides=Number($("plasterSides").value);
  if(!validPositive([L,H,T,sides],"Enter valid plaster dimensions.")) return;

  const singleArea=L*H-openings;
  if(singleArea<=0){alert("Openings cannot equal or exceed wall area.");return;}
  const area=singleArea*sides;
  const wet=withWaste(area*T);
  const dry=wet*CONFIG.dryFactorPlaster;
  const sandParts=$("plasterApplication").value==="exterior"?5:6;
  const cementM3=dry/(1+sandParts);
  const sandM3=dry*(sandParts/(1+sandParts));
  const cementBags=Math.ceil(cementM3*CONFIG.cementBulkDensityKgM3/CONFIG.cementBagKg);
  const sandOrder=roundUp(sandM3,.1);
  const s=getSettings();
  const costs=buildCost([
    {label:`Cement · ${cementBags} bags`,value:cementBags*s.cementPrice},
    {label:`Sand · ${qty(sandOrder,"m³",1)}`,value:sandOrder*s.sandPrice}
  ]);

  renderResult("plasterResult","plasterEmpty",{
    heroLabel:"Plaster area",
    heroValue:qty(area,"m²",2),
    rows:[
      {label:"Thickness",value:`${fmt(T*1000,0)} mm`},
      {label:"Mix",value:`1:${sandParts} cement:sand`},
      {label:"Plaster volume incl. wastage",value:qty(wet,"m³",2)},
      {label:"Cement",value:`${cementBags} × 50 kg bags`},
      {label:"Plaster sand",value:qty(sandOrder,"m³",1)}
    ],
    costs
  });
}



function calculateScreed(){
  const L=n("screedLength"),W=n("screedWidth"),T=n("screedThickness")/1000;
  const sandParts=Number($("screedMix").value);
  if(!validPositive([L,W,T,sandParts],"Enter valid screed dimensions.")) return;

  const area=L*W;
  const wet=withWaste(area*T);
  const dry=wet*CONFIG.dryFactorScreed;
  const cementM3=dry/(1+sandParts);
  const sandM3=dry*(sandParts/(1+sandParts));
  const cementBags=Math.ceil(cementM3*CONFIG.cementBulkDensityKgM3/CONFIG.cementBagKg);
  const sandOrder=roundUp(sandM3,.1);
  const s=getSettings();
  const costs=buildCost([
    {label:`Cement · ${cementBags} bags`,value:cementBags*s.cementPrice},
    {label:`Sand · ${qty(sandOrder,"m³",1)}`,value:sandOrder*s.sandPrice}
  ]);

  renderResult("screedResult","screedEmpty",{
    heroLabel:"Floor area",
    heroValue:qty(area,"m²",2),
    rows:[
      {label:"Thickness",value:`${fmt(T*1000,0)} mm`},
      {label:"Mix",value:`1:${sandParts} cement:sand`},
      {label:"Screed volume incl. wastage",value:qty(wet,"m³",2)},
      {label:"Cement",value:`${cementBags} × 50 kg bags`},
      {label:"Sand",value:qty(sandOrder,"m³",1)}
    ],
    costs
  });
}



function sheetCalculator(areaLength,areaWidth,deduct,sizeValue,price){
  const [sheetW,sheetL]=parsePair(sizeValue);
  const gross=areaLength*areaWidth;
  const net=gross-deduct;
  if(net<=0) return null;
  const sheetArea=sheetW*sheetL;
  const sheets=Math.ceil(withWaste(net)/sheetArea);
  return {
    gross,net,sheetW,sheetL,sheetArea,sheets,
    costs:buildCost([{label:`${sheets} sheets`,value:sheets*price}])
  };
}



function calculateShutterply(){
  const L=n("shutterLength"),W=n("shutterWidth");
  if(!validPositive([L,W],"Enter valid area dimensions.")) return;
  const result=sheetCalculator(L,W,clamp0(n("shutterDeduct")),$("shutterSize").value,clamp0(n("shutterPrice")));
  if(!result){alert("Deduction cannot equal or exceed total area.");return;}

  renderResult("shutterplyResult","shutterplyEmpty",{
    heroLabel:"Shutterply to order",
    heroValue:`${result.sheets} sheets`,
    rows:[
      {label:"Net coverage area",value:qty(result.net,"m²",2)},
      {label:"Sheet",value:`${fmt(result.sheetW*1000,0)} × ${fmt(result.sheetL*1000,0)} mm`},
      {label:"Thickness",value:$("shutterThickness").value},
      {label:"Area per sheet",value:qty(result.sheetArea,"m²",3)},
      {label:"Wastage allowance",value:`${getSettings().wastage}%`}
    ],
    costs:result.costs
  });
}



function calculateNutecBoards(){
  const L=n("nutecBoardLength"),W=n("nutecBoardWidth");
  if(!validPositive([L,W],"Enter valid area dimensions.")) return;
  const result=sheetCalculator(L,W,clamp0(n("nutecBoardDeduct")),$("nutecBoardSize").value,clamp0(n("nutecBoardPrice")));
  if(!result){alert("Deduction cannot equal or exceed total area.");return;}

  const application = $("nutecBoardApplication")?.value || "Wall Cladding";
  const floorWarning = application === "Floor"
    ? " Confirm floor board specification and support spacing before purchase."
    : "";

  renderResult("nutecboardsResult","nutecboardsEmpty",{
    heroLabel:"Nutec boards to order",
    heroValue:`${result.sheets} boards`,
    rows:[
      {label:"Application",value:application},
      {label:"Net coverage area",value:qty(result.net,"m²",2)},
      {label:"Board",value:`${fmt(result.sheetW*1000,0)} × ${fmt(result.sheetL*1000,0)} mm`},
      {label:"Thickness",value:$("nutecBoardThickness").value},
      {label:"Area per board",value:qty(result.sheetArea,"m²",3)},
      {label:"Wastage allowance",value:`${getSettings().wastage}%`}
    ],
    costs:result.costs
  });
  if(floorWarning){
    const note = app.querySelector("#nutecboardsResult .result-note");
    if(note) note.textContent += floorWarning;
  }
}



function calculateCeiling(){
  const L=n("ceilingLength"),W=n("ceilingWidth"),corniceLen=n("cornicePieceLength");
  if(!validPositive([L,W,corniceLen],"Enter valid room dimensions and cornice length.")) return;

  const [boardW,boardL]=parsePair($("ceilingBoardSize").value);
  const area=L*W;
  const boardArea=boardW*boardL;
  const boards=Math.ceil(withWaste(area)/boardArea);
  const perimeter=2*(L+W);
  const cornicePieces=Math.ceil(perimeter/corniceLen);
  const price=clamp0(n("ceilingBoardPrice"));
  const costs=buildCost([{label:`Ceiling boards · ${boards}`,value:boards*price}]);

  renderResult("ceilingResult","ceilingEmpty",{
    heroLabel:"Ceiling boards to order",
    heroValue:`${boards} boards`,
    rows:[
      {label:"Ceiling area",value:qty(area,"m²",2)},
      {label:"Board size",value:`${fmt(boardW*1000,0)} × ${fmt(boardL*1000,0)} mm`},
      {label:"Board area",value:qty(boardArea,"m²",3)},
      {label:"Perimeter",value:qty(perimeter,"m",2)},
      {label:`Cornice pieces @ ${fmt(corniceLen,1)} m`,value:`${cornicePieces} pieces`},
      {label:"Wastage allowance",value:`${getSettings().wastage}%`}
    ],
    costs
  });
}



function calculateInsulation(){
  const L=n("insulationLength"),W=n("insulationWidth"),surfaces=n("insulationSurfaces"),coverage=n("insulationCoverage");
  if(!validPositive([L,W,surfaces,coverage],"Enter valid surface dimensions, number of surfaces and product coverage.")) return;

  const gross=L*W*surfaces;
  const net=gross-clamp0(n("insulationDeduct"));
  if(net<=0){alert("Deduction cannot equal or exceed total insulation area.");return;}
  const orderArea=withWaste(net);
  const rolls=Math.ceil(orderArea/coverage);
  const price=clamp0(n("insulationPrice"));
  const costs=buildCost([{label:`Insulation rolls/packs · ${rolls}`,value:rolls*price}]);

  renderResult("insulationResult","insulationEmpty",{
    heroLabel:"Insulation to order",
    heroValue:`${rolls} rolls / packs`,
    rows:[
      {label:"Net area",value:qty(net,"m²",2)},
      {label:"Area incl. wastage",value:qty(orderArea,"m²",2)},
      {label:"Coverage per roll / pack",value:qty(coverage,"m²",2)}
    ],
    costs
  });
}



function calculateNutecGate(){
  const W=n("gateWidth"),H=n("gateHeight");
  if(!validPositive([W,H],"Enter valid gate width and height.")) return;

  const [plankNominalW,plankLength]=parsePair($("gatePlank").value);
  const overlap=CONFIG.nutecPlankOverlapM;
  const exposed=plankNominalW-overlap;
  if(exposed<=0){alert("Invalid plank overlap.");return;}

  const direction=$("gateDirection").value;
  let courses,piecesPerCourse,raw;

  if(direction==="horizontal"){
    courses=Math.ceil(H/exposed);
    piecesPerCourse=Math.ceil(W/plankLength);
    raw=courses*piecesPerCourse;
  }else{
    courses=Math.ceil(W/exposed);
    piecesPerCourse=Math.ceil(H/plankLength);
    raw=courses*piecesPerCourse;
  }

  const order=Math.ceil(withWaste(raw));
  const price=clamp0(n("gatePlankPrice"));
  const costs=buildCost([{label:`Nutec planks · ${order}`,value:order*price}]);

  renderResult("nutecgateResult","nutecgateEmpty",{
    heroLabel:"Nutec planks to order",
    heroValue:`${order} planks`,
    rows:[
      {label:"Gate area",value:qty(W*H,"m²",2)},
      {label:"Plank nominal size",value:`${fmt(plankNominalW*1000,0)} mm × ${fmt(plankLength,1)} m`},
      {label:"Standard overlap",value:"25 mm"},
      {label:"Exposed plank cover",value:`${fmt(exposed*1000,0)} mm`},
      {label:direction==="horizontal"?"Horizontal courses":"Vertical plank lines",value:String(courses)},
      {label:"Pieces per course / line",value:String(piecesPerCourse)},
      {label:"Raw plank count",value:String(raw)},
      {label:"Wastage allowance",value:`${getSettings().wastage}%`}
    ],
    costs
  });
}



function calculateNutecHouse(){
  const L=n("houseLength"),W=n("houseWidth"),H=n("houseHeight");
  if(!validPositive([L,W,H],"Enter valid house length, width and wall height.")) return;

  const openings=clamp0(n("houseOpenings"));
  const perimeter=2*(L+W);
  const grossWall=perimeter*H;
  const netWall=grossWall-openings;
  if(netWall<=0){alert("Door/window openings cannot equal or exceed the total wall area.");return;}

  const [plankW,plankL]=parsePair($("housePlank").value);
  const exposed=plankW-CONFIG.nutecPlankOverlapM;
  const plankEffectiveArea=exposed*plankL;
  const wallPlanks=Math.ceil(withWaste(netWall)/plankEffectiveArea);

  const floorArea=L*W;
  const [ceilingW,ceilingL]=parsePair($("houseCeilingBoard").value);
  const ceilingBoardArea=ceilingW*ceilingL;
  const ceilingBoards=Math.ceil(withWaste(floorArea)/ceilingBoardArea);

  const [floorW,floorL]=parsePair($("houseFloorBoard").value);
  const floorBoardArea=floorW*floorL;
  const floorBoards=Math.ceil(withWaste(floorArea)/floorBoardArea);

  const plankPrice=clamp0(n("housePlankPrice"));
  const ceilingPrice=clamp0(n("houseCeilingPrice"));
  const floorPrice=clamp0(n("houseFloorPrice"));

  const costs=buildCost([
    {label:`Wall planks · ${wallPlanks}`,value:wallPlanks*plankPrice},
    {label:`Ceiling boards · ${ceilingBoards}`,value:ceilingBoards*ceilingPrice},
    {label:`15 mm floor boards · ${floorBoards}`,value:floorBoards*floorPrice}
  ]);

  renderResult("nutechouseResult","nutechouseEmpty",{
    heroLabel:"Nutec house envelope",
    heroValue:`${fmt(L,2)} × ${fmt(W,2)} m`,
    sections:[
      {title:"Wall Cladding",rows:[
        {label:"External perimeter",value:qty(perimeter,"m",2)},
        {label:"Net external wall area",value:qty(netWall,"m²",2)},
        {label:"Nutec plank",value:`${fmt(plankW*1000,0)} mm × ${fmt(plankL,1)} m`},
        {label:"Ship-lap overlap",value:"25 mm"},
        {label:"Effective exposed plank width",value:`${fmt(exposed*1000,0)} mm`},
        {label:"Wall planks to order",value:`${wallPlanks} planks`}
      ]},
      {title:"Nutec Ceiling",rows:[
        {label:"Ceiling area",value:qty(floorArea,"m²",2)},
        {label:"Ceiling board size",value:`${fmt(ceilingW*1000,0)} × ${fmt(ceilingL*1000,0)} mm`},
        {label:"Ceiling boards to order",value:`${ceilingBoards} boards`}
      ]},
      {title:"15 mm Nutec Floor",rows:[
        {label:"Floor area",value:qty(floorArea,"m²",2)},
        {label:"Floor board",value:`15 mm · ${fmt(floorW*1000,0)} × ${fmt(floorL*1000,0)} mm`},
        {label:"Floor boards to order",value:`${floorBoards} boards`}
      ]}
    ],
    costs
  });
}



function calculateMetalRoof(resultId,emptyId,roofWidth,sheetLength,slopes,cover,extra,price,label){
  if(!validPositive([roofWidth,sheetLength,slopes,cover],"Enter valid roof dimensions.")) return;
  const perSlope=Math.ceil(roofWidth/cover);
  const baseSheets=perSlope*slopes;
  const sheets=baseSheets+Math.max(0,Math.ceil(extra));
  const runningMetres=sheets*sheetLength;
  const roofArea=roofWidth*sheetLength*slopes;
  const costs=buildCost([{label:`${label} · ${fmt(runningMetres,2)} running m`,value:runningMetres*price}]);

  renderResult(resultId,emptyId,{
    heroLabel:`${label} sheets to order`,
    heroValue:`${sheets} sheets`,
    rows:[
      {label:"Effective cover width",value:`${fmt(cover*1000,0)} mm`},
      {label:"Sheets per roof slope",value:String(perSlope)},
      {label:"Roof slopes",value:String(slopes)},
      {label:"Sheet length",value:qty(sheetLength,"m",2)},
      {label:"Total running metres",value:qty(runningMetres,"m",2)},
      {label:"Approx. roof slope area",value:qty(roofArea,"m²",2)},
      {label:"Extra sheets added",value:String(Math.max(0,Math.ceil(extra)))}
    ],
    costs
  });
}



function calculateIBR(){
  calculateMetalRoof(
    "ibrResult","ibrEmpty",
    n("ibrRoofWidth"),n("ibrSheetLength"),Number($("ibrSlopes").value),
    CONFIG.ibrCoverM,n("ibrExtraSheets"),clamp0(n("ibrPrice")),"IBR"
  );
}



function calculateCorrugated(){
  const cover=Number($("corrProfile").value);
  const profile=cover===CONFIG.corrugated85CoverM?"8.5/76 corrugated":"10.5/76 corrugated";
  calculateMetalRoof(
    "corrugatedResult","corrugatedEmpty",
    n("corrRoofWidth"),n("corrSheetLength"),Number($("corrSlopes").value),
    cover,n("corrExtraSheets"),clamp0(n("corrPrice")),profile
  );
}



function sheetsAcrossBigSix(width){
  if(width<=CONFIG.bigSixOverallFirstM) return 1;
  return 1 + Math.ceil((width-CONFIG.bigSixOverallFirstM)/CONFIG.bigSixNetAdditionalM);
}

function rowsDownSlope(slopeLength,sheetLength,endLap){
  if(slopeLength<=sheetLength) return 1;
  const effectiveAdditional=sheetLength-endLap;
  if(effectiveAdditional<=0) return Infinity;
  return 1 + Math.ceil((slopeLength-sheetLength)/effectiveAdditional);
}

function calculateBigSix(){
  const width=n("b6RoofWidth");
  const slopeLength=n("b6SlopeLength");
  const sheetLength=Number($("b6SheetLength").value);
  const slopes=Number($("b6Slopes").value);
  const endLap=n("b6EndLap")/1000;
  const extra=Math.max(0,Math.ceil(n("b6ExtraSheets")));
  const price=clamp0(n("b6Price"));

  if(!validPositive([width,slopeLength,sheetLength,slopes],"Enter valid roof and sheet dimensions.")) return;

  if(!Number.isFinite(endLap) || endLap < 0 || endLap >= sheetLength){alert("End lap must be nonnegative and smaller than the sheet length.");return;}
  const across=sheetsAcrossBigSix(width);
  const rows=rowsDownSlope(slopeLength,sheetLength,endLap);
  if(!Number.isFinite(rows)){alert("End lap must be smaller than the sheet length.");return;}

  const base=across*rows*slopes;
  const sheets=base+extra;
  const firstRowCover = CONFIG.bigSixOverallFirstM + Math.max(0,across-1)*CONFIG.bigSixNetAdditionalM;
  const longitudinalCover = sheetLength + Math.max(0,rows-1)*(sheetLength-endLap);
  const costs=buildCost([{label:`Big Six sheets · ${sheets}`,value:sheets*price}]);

  renderResult("bigsixResult","bigsixEmpty",{
    heroLabel:"Big Six sheets to order",
    heroValue:`${sheets} sheets`,
    rows:[
      {label:"Sheets across each row",value:String(across)},
      {label:"Rows down each slope",value:String(rows)},
      {label:"Roof slopes",value:String(slopes)},
      {label:"First-sheet overall width",value:"920 mm"},
      {label:"Additional sheet net cover",value:"875 mm"},
      {label:"Calculated cross-roof cover",value:qty(firstRowCover,"m",3)},
      {label:"Sheet length",value:qty(sheetLength,"m",1)},
      {label:"End lap used",value:`${fmt(endLap*1000,0)} mm`},
      {label:"Calculated slope cover",value:qty(longitudinalCover,"m",3)},
      {label:"Extra sheets added",value:String(extra)}
    ],
    costs
  });
}

const calculators = {concrete:calculateConcrete, masonry:calculateMasonry, plaster:calculatePlaster, screed:calculateScreed, shutterply:calculateShutterply, nutecboards:calculateNutecBoards, ceiling:calculateCeiling, insulation:calculateInsulation, nutecgate:calculateNutecGate, nutechouse:calculateNutecHouse, ibr:calculateIBR, corrugated:calculateCorrugated, bigsix:calculateBigSix};
app.querySelectorAll("button").forEach(button=>button.type="button");
const settingsButton=app.querySelector(".toolbar-actions .btn-secondary");
settingsButton?.setAttribute("aria-controls","settingsDrawer");
settingsButton?.setAttribute("aria-expanded","false");
settingsButton?.setAttribute("aria-label","Calculator settings");
app.querySelector(".toolbar-actions .btn-primary")?.setAttribute("aria-label","Print or save calculator result as PDF");
app.querySelector(".settings-head .icon-button")?.setAttribute("aria-label","Close calculator settings");
$("settingsDrawer")?.setAttribute("aria-hidden","true");
app.addEventListener("click",event=>{
  const button=event.target.closest("button");
  if (!button || !app.contains(button)) return;
  if (button.matches(".calc-nav button[data-target]")) { activateCalculator(button.dataset.target,true,true); return; }
  if (button.matches(".toolbar-actions .btn-secondary")) { setSettingsOpen(!$("settingsDrawer").classList.contains("open")); return; }
  if (button.matches(".toolbar-actions .btn-primary") || button.dataset.calculatorAction==="print") { window.print(); return; }
  if (button.matches(".settings-head .icon-button")) { setSettingsOpen(false); return; }
  if (button.matches(".settings-actions .btn-primary")) { saveSettings(); return; }
  if (button.matches(".settings-actions .btn-secondary")) { resetSettings(); return; }
  if (button.dataset.calculatorAction==="copy") { copyActiveResult(); return; }
  const view=button.closest(".calc-view");
  if (!view || !button.closest(".form-card .form-actions")) return;
  if (button.classList.contains("btn-secondary")) { clearCalc(view.id); return; }
  if (button.classList.contains("btn-primary")) {
    invalidate(view);
    if (!validateInputs(view)) return;
    try { calculators[view.id]?.(); }
    catch { invalidate(view); alert("Unable to calculate these values. Check the dimensions, counts and selected product sizes."); }
  }
});
app.addEventListener("input",event=>{
  const field=event.target;
  field.removeAttribute("aria-invalid");
  if (field.id==="calculatorSearch") {
    const query=field.value.trim().toLowerCase();
    app.querySelectorAll(".calc-nav button[data-target]").forEach(button=>{
      const match=`${button.dataset.name || ""} ${button.dataset.keywords || ""} ${button.textContent}`.toLowerCase().includes(query);
      button.hidden=!match;
      button.style.display=match ? "" : "none";
    });
    app.querySelectorAll(".nav-group").forEach(group=>{
      const visible=[...group.querySelectorAll("button[data-target]")].some(button=>!button.hidden);
      group.hidden=!visible;
      group.style.display=visible ? "" : "none";
    });
    return;
  }
  if (field.closest(".settings-drawer")) invalidateAll();
  else if (field.closest(".calc-view")) invalidate(field.closest(".calc-view"));
});
app.addEventListener("change",event=>{
  const field=event.target;
  if (field.id==="mobileCalculatorSelect") { activateCalculator(field.value,true,true); return; }
  if (field.id==="nutecBoardApplication") updateBoardApplication();
  if (field.closest(".settings-drawer")) invalidateAll();
  else if (field.closest(".calc-view")) invalidate(field.closest(".calc-view"));
});
app.addEventListener("keydown",event=>{
  if (event.key==="Escape" && $("settingsDrawer")?.classList.contains("open")) setSettingsOpen(false);
  if (event.key==="Enter" && event.target.matches('.calc-view input[type="number"]')) { event.preventDefault(); event.target.closest(".calc-view").querySelector(".form-card .form-actions .btn-primary")?.click(); }
});
window.addEventListener("hashchange",()=>{ if (app.isConnected) activateCalculator(routeCalculator(),false); });
window.addEventListener("popstate",()=>{ if (app.isConnected) activateCalculator(routeCalculator(),false); });
loadSettings();
updateBoardApplication();
activateCalculator(routeCalculator(),false);
  });
}
window[scriptKey]=mount;
if (document.readyState==="loading") document.addEventListener("DOMContentLoaded",mount,{once:true});
else mount();
document.addEventListener("shopify:section:load",mount);
})();
  } catch(e) { console.error(e); }
})();

})();
